import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { ImageModule } from 'primeng/image';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TagModule } from 'primeng/tag';
import { MessageModule } from 'primeng/message';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ContextMenuModule } from 'primeng/contextmenu';
import { FileUploadModule } from 'primeng/fileupload';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { MenubarModule } from 'primeng/menubar';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { DataModule } from './app/data/data.module';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { PickListModule } from 'primeng/picklist';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { CoreModule } from './app/core/core.module';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { GuardService } from './app/guards/guard.service';
import { UserPermissionsGuard } from './app/guards/app-routing.guard';
import { NotificationService } from './app/layout/shared/notification/notification.service';
import { MessageService } from 'primeng/api';
import { DatePipe, LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    providePrimeNG({
      theme: { preset: Aura }
    }),
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      TableModule,
      DialogModule,
      ButtonModule,
      CoreModule,
      SelectModule,
      MultiSelectModule,
      CommonModule,
      ListboxModule,
      PickListModule,
      DatePickerModule,
      CheckboxModule,
      ToggleButtonModule,
      InputTextModule,
      InputNumberModule,
      DataModule,
      ToastModule,
      ReactiveFormsModule,
      TooltipModule,
      MenubarModule,
      TieredMenuModule,
      FileUploadModule,
      ContextMenuModule,
      AutoCompleteModule,
      AutoCompleteModule,
      MessageModule,
      TagModule,
      ImageCropperModule,
      ImageModule
    ),
    DatePipe,
    MessageService,
    NotificationService,
    UserPermissionsGuard,
    GuardService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideAnimations()
  ]
}).catch(err => console.error(err));

